import {Component, Input, OnInit} from '@angular/core';
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {CadPausasProgramadasComponent} from "../cad-pausas-programadas/cad-pausas-programadas.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import { HistoricoPausasComponent } from '../historico-pausas/historico-pausas.component';

declare  var moment;
@Component({
  selector: 'app-tela-pausas-programadas',
  templateUrl: './tela-pausas-programadas.component.html',
  styleUrls: ['./tela-pausas-programadas.component.scss']
})
export class TelaPausasProgramadasComponent implements OnInit {
  @Input() empresa: any = {};
  mesesProgramados = [];
  modalConfirmacao = false;
  pausaParaRemover: any = null;

  constructor(private empresaService: EmpresasService, private dialogService: DialogService) {
  }

  ngOnInit(): void {
    let i = 0;
    this.empresa.pausasProgramadas.forEach( (pausaProgramada: any) => {
      let mesDescricao = moment(pausaProgramada.dataInicio).format('MMMM');

      if(this.mesesProgramados.indexOf(mesDescricao) === -1)
        this.mesesProgramados.push(mesDescricao)


      pausaProgramada.mesDescricao = mesDescricao;
      pausaProgramada.i = i++;

    })
  }


  novaPausa() {

    let windowRef: any = this.dialogService.open({
      title: 'Cadastrar Pausa Programada',
      content: CadPausasProgramadasComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: 500
    });

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.windowRef = windowRef

    windowRef.result.subscribe((result: any) => {
      if(result){

      }
    })

  }

  editarPausa(pausaProgramada: any){
    let windowRef: any = this.dialogService.open({
      title: 'Cadastrar Pausa Programada',
      content: CadPausasProgramadasComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: 500
    });

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.pausaProgramada = Object.assign({}, pausaProgramada);
    windowRef.content.instance.windowRef = windowRef

    windowRef.result.subscribe((result: any) => {
      if(result){
        Object.assign(pausaProgramada, result);
      }
    })
  }

  obtenhaPausasDoMes(mes: string) {
    return this.empresa.pausasProgramadas.filter( (pausaProgramada: any) => pausaProgramada.mesDescricao === mes)
  }

  obtenhaTempoIndisponivel(pausaProgramada: any) {
    if(!pausaProgramada.dataFim) return `tempo indeterminado`

    let diffHoras = moment(pausaProgramada.dataFim).diff(moment(pausaProgramada.dataInicio), 'h');


    if(diffHoras >  0){
      if(diffHoras <= 24)  return String(`${diffHoras} horas`)

      let dias = moment(pausaProgramada.dataFim).diff(moment(pausaProgramada.dataInicio), 'd');

      if(dias <= 1)  return String(`${dias} dia`)

      return String(`${dias} dias`)
    } else {
       let diffMinutos =   moment(pausaProgramada.dataFim).diff(moment(pausaProgramada.dataInicio), 'm');

       return String(`${diffMinutos} min`)
    }

  }

  verHistorico() {
    let windowRef: any = this.dialogService.open({
      title: 'Histórico de Pausas Programadas',
      content: HistoricoPausasComponent,
      minWidth: 900,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight >  800 ? 800 :  window.innerHeight
    });
  }

  confirmarRemocao(event: Event, pausa: any) {
    event.stopPropagation(); // Impede que o click propague para o card
    this.pausaParaRemover = pausa;
    this.modalConfirmacao = true;

  }

  fecharModal() {
    this.modalConfirmacao = false;
    this.pausaParaRemover = null;
  }

  removerPausa() {
    if (this.pausaParaRemover) {
      this.pausaParaRemover.removendo = true;
      // Aqui você deve chamar o serviço para remover a pausa
      this.empresaService.excluaPausaPromagrada(this.empresa, this.pausaParaRemover).then(() => {
        this.pausaParaRemover.removida = true;
        this.fecharModal();
        // Atualizar a lista se necessário
      }).catch(erro => {
        console.error('Erro ao remover pausa:', erro);
        alert(erro)
      });
    }
  }
}
